import { getEmailRecipientTypeId } from '../helpers/enum'
import httpClient from '../utils/axios'
import {
  handleServiceResponse,
  handleServiceError,
} from '../utils/serviceResponseHelper'

function getActiveCaseParticipantsWithRoles(caseId) {
  const url = `${window.config.CASE_API_URL}/api/cases/GetActiveCaseParticipantsWithRoles/${caseId}`
  return httpClient.get(url).then(
    response => handleServiceResponse(response),
    error => handleServiceError(error)
  )
}

const createCommunication = async (caseId, componentForm) => {
  return await httpClient.post(
    `${window.config.CASE_API_URL}/api/casecommunications/create/${caseId}/`,
    getFormData(componentForm),
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

const getFormData = componentForm => {
  if (!componentForm.subject) return
  var formData = new FormData()

  formData.set('subject', componentForm.subject)
  formData.set('body', componentForm.body ? componentForm.body : ' ')
  formData.set(
    'CommunicationVisibilityType',
    componentForm.communicationVisibilityType
  )

  if (componentForm.communicationSubmissionTypeId) {
    formData.set(
      'communicationSubmissionTypeId',
      componentForm.communicationSubmissionTypeId
    )
  }
  if (
    (componentForm.activeCaseParticipants !== null ||
      componentForm.activeCaseParticipants !== undefined) &&
    componentForm.activeCaseParticipants?.length > 0
  ) {
    const dto = componentForm.activeCaseParticipants.map(item => {
      return {
        sentToUserId: item.participantUserId,
        emailRecipientType:
          item.distribution === undefined
            ? null
            : getEmailRecipientTypeId(item.distribution),
        email: item.personEmail,
      }
    })
    const filteredDto = dto.filter(dist => dist.emailRecipientType !== null)
    const dtoJson = JSON.stringify(filteredDto)
    formData.append('activeCaseParticipantsEmailModel', dtoJson)
  }

  formData.append(
    'sendToManagerDetails',
    JSON.stringify(componentForm.sendToManagerDetails)
  )

  return formData
}

export default {
  getActiveCaseParticipantsWithRoles,
  createCommunication,
}
